import React from 'react';
import Modal from 'react-modal';
import CommercialTable from '../../../../common/components/commercialTable/commercialTable';
import notpriorizedModalColumns from './columns';

export const floatingInvCustomStyles = {
  'overlay': {
    'background': 'rgba(0, 0, 0, 0.6)',
    'zIndex': '1000',
  },
  'content': {
    'left': '25%',
    'width': '50%',
    'height': 'auto',
    'padding': '0px',
    'display': 'flex',
    'flexDirection': 'column',
    'justifyContent': 'center',
    'backgroundColor': 'transparent',
    'margin': '0px',
    'border': '0px',
    'overflowY': 'hidden !important',
  },
};


const NotPriorizedModal = ({isOpen, seIsOpen, data = []}) => {
  return (
    <Modal
      isOpen={isOpen}
      style={floatingInvCustomStyles}
    >
      <div className='not-priorized-container'>
        <div className='not-priorized-title'>
          <div>Tiene vehículos pendientes por priorizar</div>
          <div onClick={() => seIsOpen(false)} className='not-priorized-close'>&#xd7;</div>
        </div>
        <div>
          <CommercialTable
            columns={notpriorizedModalColumns}
            data={data}
            pagination={false}
            isSmallCell={false}
            tableWrapperStyles={'floating-empty'}
            tableType={'fixed'}
          />
        </div>
      </div>
    </Modal>
  );
};

export default NotPriorizedModal;
